import { WholesaleSales } from "../features/wholesale/pages/wholesale-sales"
import { DashboardLayout } from "../layouts/DashboardLayout"

export default function WholesaleSalesPage() {
  return (
    <DashboardLayout>
      <WholesaleSales />
    </DashboardLayout>
  )
}
